import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ImpersonationState {
  impersonatedUser: string | null;
  impersonatedUserEmail?: string | null;
}

export const defaultImpersonationState: ImpersonationState = {
  impersonatedUser: null,
  impersonatedUserEmail: null,
};

export const IMPERSONATION_STATE = 'impersonationState';
export const IMPERSONATION_HEADER_USER_ID = 'X-Impersonation-User-Id';

@Injectable({
  providedIn: 'root',
})
export class AuthImpersonationService {
  private readonly state$: BehaviorSubject<ImpersonationState>;

  constructor(
  ) {
    //for also maintaining impersonation state across page reloads
    const savedState = localStorage.getItem(IMPERSONATION_STATE);
    const initialState = savedState
      ? { ...defaultImpersonationState, ...JSON.parse(savedState) }
      : defaultImpersonationState;

    this.state$ = new BehaviorSubject<ImpersonationState>(initialState);
  }

  get state() {
    return this.state$.asObservable();
  }

  setState(state: ImpersonationState) {
    const normalizedState = { ...defaultImpersonationState, ...state };
    this.state$.next(normalizedState);
    window.localStorage.setItem(IMPERSONATION_STATE, JSON.stringify(normalizedState));
  }

  exitImpersonation() {
    this.state$.next({ ...defaultImpersonationState });
    window.localStorage.removeItem(IMPERSONATION_STATE);
  }

  getStateValue(): ImpersonationState {
    return this.state$.getValue();
  }

  isImpersonating(): boolean {
    return this.state$.getValue().impersonatedUser !== null;
  }

}
